import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./../node_modules/bootstrap/dist/css/bootstrap-grid.css";
import "./../node_modules/font-awesome/css/font-awesome.min.css";
import { Layout } from "./views/Layout/Layout";
import { LayoutNoHeader } from "./views/Layout/LayoutNoHeader";
import "./Style.scss";
import ReactGA from "react-ga";

function App() {
  // ReactGA.initialize("UA-142628390-6");
  // ReactGA.pageview(window.location.pathname + window.location.search);
  useEffect(() => {
    // Initialize Microsoft Clarity
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "huu4c6svgn");

    //  // Log a pageview
    //  window.clarity("pageview");

    // Initialize Google Analytics
    ReactGA.initialize("UA-142628390-6");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route path="/unsubscribe" component={LayoutNoHeader} />
          <Route path="/" component={Layout} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
